import { Component } from '@angular/core';

@Component({
  selector: 'lib-adc-dashboard',
  templateUrl: './adc-dashboard.component.html',
  styleUrls: ['./adc-dashboard.component.css']
})
export class AdcDashboardComponent {

}
